export const NETWORK_TYPES = {
    VMOTION: 'vMotion',
    MANAGEMENT: 'Management',
    INTERNET: 'Internet',
    DC1: 'Direct Connect Network 1',
    DC2: 'Direct Connect Network 2'
};


// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/constants.ts